<template>
  <div class="row">
    <div class="col-md-12">
      <!--h4><i class="fa fa-address-card fa-fw text-muted"></i> Avatar</h4 -->
      <div class="media">
        <div class="media-left">
          <img v-if="user.picture" :src="user.picture.slug | media({width: '150'})" :alt="user.nickname">
          <img v-if="!user.picture" src="/beta/static/default-user-128.png" :alt="user.nickname" width="150" height="150">
        </div>
        <div class="media-body">
        </div>
      </div>
      <!-- h4><i class="fa fa-universal-access fa-fw text-muted"></i> Account Settings</h4 -->
      <hr>
      <ul class="nav nav-list">
        <li><a><b>Username:</b> {{ user.nickname }}</a></li>
        <li><a><b>First Name:</b> {{ user.firstName }}</a></li>
        <li><a><b>Last Name:</b> {{ user.lastName }}</a></li>
        <li><a><b>Email:</b> {{ user.email }}</a></li>
        <li><a><b>Mobile:</b> {{ user.phone }}</a></li>
      </ul>
      <hr>
      <!-- h4><i class="fa fa-map fa-fw text-muted"></i> Addresses</h4 -->
      <ul class="nav nav-list">
        <li><a><b>Company:</b> {{ user.company }}</a></li>
        <li><a :href="user.website" target="_blank"><b>Website:</b> {{ user.website }}</a></li>
        <li><a><b>Country:</b> {{ user.country }}</a></li>
        <li><a><b>City:</b> {{ user.city }}</a></li>
        <li><a><b>ZIP Code:</b> {{ user.zipCode }}</a></li>
      </ul>
      <!-- h4><i class="fa fa-wpforms fa-fw text-muted"></i> Specialists</h4 -->
      <hr>
      <ul class="nav nav-list">
        <li v-if="user.professionalActivities && user.professionalActivities.length">
          <a><b>Professional Activities:</b>
            <span class="text-capitalize" v-bind:key="idx" v-for="(pa, idx) in user.professionalActivities">{{ pa }}{{ (idx < user.professionalActivities.length - 1) ? ' / ' : '' }}</span></a>
        </li>
        <li v-if="user.clinicalAreas && user.clinicalAreas.length">
          <a><b>Clinical Area:</b>
            <span class="text-capitalize" v-bind:key="idx" v-for="(ca, idx) in user.clinicalAreas">{{ ca }}{{ (idx < user.clinicalAreas.length - 1) ? ' / ' : '' }}</span></a>
        </li>
        <li v-if="user.modalities && user.modalities.length">
          <a><b>Modality:</b>
            <span class="text-capitalize" v-bind:key="idx" v-for="(mod, idx) in user.modalities">{{ mod }}{{ (idx < user.modalities.length - 1) ? ' / ' : '' }}</span></a>
        </li>
      </ul>
    </div>
  </div>
</template>
<script>
export default {
  name: 'ViewProfile',
  data() {
    return {
      user: {}
    }
  },
  created: function() {
    this.fetchData()
  },
  methods: {
    fetchData: function() {
      this.$http.get('user/me').then(
        response => {
          this.user = response.data
        },
        err => {
          // error callback
          console.log(err)
        }
      )
    }
  }
}
</script>
<style scoped>
.account-container .account-body .nav.nav-list > li > a {
  padding: 0;
  color: #777;
}
.account-container .account-body .nav.nav-list {
    margin-bottom: 30px;
}
.account-container .account-body .nav.nav-list>li+li {
    margin-top: 5px;
}
.nav > li > a {
  padding: 10px 15px;
}
.nav > li,
.nav > li > a {
  position: relative;
  display: block;
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/pages/profile/ViewProfile.vue